<template>
  <div class="proposeList">
    <!-- <div class="header">
        <img src="@/assets/new/fan.png"  @click="goHome" alt="">
        <span>我的奖励</span>
    </div> -->
    <img src="@/assets/c/img_bjtwo2.png" class="img_jd_b" alt=""/>
    <div class="jieview">
      <div class="jiefix">
        <div class="fone" @click="setGzshow">
          <img src="@/assets/c/img_gzsm.png" class="bg" alt=""/>
          <div class="guiview">
            <!-- <img
                src="@/assets/c/icon_gz.png"
                class="icon_gz"
                alt=""
            /> -->
            <span class="guiname">{{ $t("new.guism") }}</span>
          </div>
        </div>
        <div class="fone" @click="getjie(1)">
          <img src="@/assets/c/img_gzsm.png" class="bg" alt=""/>
          <div class="guiview">
            <!-- <img
                src="@/assets/c/icon_yqzx.png"
                class="icon_gz"
                alt=""
            /> -->
            <span class="guiname">{{ $t("new.xiaojilu") }}</span>
          </div>
        </div>
      </div>
      <div class="jienav jienavone">
        <img src="@/assets/c/img_gmbjtwo.png" class="bg" alt=""/>
        <div class="navitem">
          <div
              class="goumai"
              style="width: 100px; height: 37px; margin-top: 0"
          >
            <img src="@/assets/c/img_bjbtn.png" class="bg" alt=""/>
            <div class="gouview">{{ icoData.ico?.name_en }}</div>
          </div>
          <div class="xianview">
            <img src="@/assets/c/img_sl.png" class="bg" alt=""/>
            <div class="xianitem">{{ icoData.ico?.word1 }}</div>
          </div>
          <div class="jindu">
            <!-- <div class="jins" :style="{ style: percentage + 'px' }"> -->
            <div
                class="jins"
                style="width: 100%; position: relative"
            >
              <img
                  src="@/assets/c/jindu.gif"
                  class="bg"
                  alt=""
                  style="
                                    position: absolute;
                                    left: -10px;
                                    width: 110%;
                                "
              />
            </div>
          </div>
          <div
              class="jinshu animate__animated animate__flash animate__infinite"
              style="animation-duration: 3s"
          >
            {{ icoData.ico.word2 }}
          </div>
        </div>
      </div>

      <div class="jienav">
        <img src="@/assets/c/img_bj2.png" class="bg" alt=""/>
        <div class="navitem" style="padding-top: 30px">
          <div
              class="navs"
              style="flex-wrap: wrap; justify-content: center"
          >
            <div
                class="shuview"
                v-bind:class="{
                                sactive: select_number == item.num,
                            }"
                v-for="(item, index) in icoData.ico.price_info"
                :key="index"
                @click="changeNumber(item)"
            >
              <img
                  src="@/assets/c/img_slbj_s.png"
                  class="img_slbj_s"
                  alt=""
              />
              <img
                  src="@/assets/c/img_slbj_n.png"
                  class="img_slbj_n"
                  alt=""
              />
              <div class="shuitems">
                ${{ item.num }}
              </div>
            </div>
          </div>
          <div class="tishi">
            {{ $t("new.jihuo_qia") }}{{
              select_number_gmc
            }}{{ $t("new.jihuo_hou") }}
          </div>
          <div class="goumai" @click="pay">
            <img
                src="@/assets/c/img_gmanbj.png"
                class="bg"
                alt=""
            />
            <div class="gouview">
              {{ $t("new.gname") }}
            </div>
          </div>
        </div>
      </div>

      <div class="jienav jienavtwo">
        <img src="@/assets/c/img_bj3.png" class="bg" alt=""/>
        <div class="navitem">
          <div class="navstwo">
            <div
                class="shuview sactive"
                style="justify-content: center"
            >
              <div class="shuone" @click="getjie(1)">
                                <span class="gouname">{{
                                    $t("new.wocanyu")
                                  }}</span>
                <img
                    src="@/assets/c/wen.png"
                    class="wen"
                    alt=""
                />
              </div>
              <div class="dnum">{{ buy_ico }} GMC</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 消费记录弹窗等 -->
    <van-popup
        :close-on-click-overlay="false"
        v-model="jdshow"
        position="center"
        :style="{ background: 'none' }"
        :overlay-style="{ background: 'rgba(0, 0, 0, 0.7)' }"
    >
      <div class="popview van-jdpop animate__animated animate__zoomIn">
        <img src="@/assets/c/pbtntwo.png" class="bg" alt=""/>
        <div class="jdview">
          <div class="jshead">
            <img src="@/assets/c/pbtnone.png" class="bg" alt=""/>
            <div class="jheadview">
              {{ $t("new.xiaojilu") }}
            </div>
          </div>
          <div class="tview oneview">
            <div class="tone">{{ $t("new.shijian") }}</div>
            <!--                        <div class="ttwo">{{ $t("new.jine") }}</div>-->
            <div class="tthree">{{ $t("new.shuliang") }}</div>
          </div>
          <div
              class="tview"
              style="overflow-y: scroll; height: 280px"
          >
            <div
                class="tlist" style="width:97%"
                v-for="(item, index) in icoData.ico_order"
                :key="index"
            >
                            <span class="tone">
                                {{ item.created_at }}
                            </span>
              <!--                            <span class="ttwo"> ${{ parseFloat(item.usdt) }} </span>-->
              <span class="tthree">
                                {{ parseFloat(item.gmc) }}
                            </span>
            </div>
          </div>
          <div class="jsheadbot" @click.stop="jdshow = false">
            <img src="@/assets/c/pbtnthree.png" class="bg" alt=""/>
            <div class="jheadview">
              {{ $t("new.queren") }}
            </div>
          </div>
        </div>
      </div>
    </van-popup>

    <van-popup
        :close-on-click-overlay="false"
        v-model="gzshow"
        position="center"
        :style="{ background: 'none' }"
        :overlay-style="{ background: 'rgba(0, 0, 0, 0.7)' }"
    >
      <div
          class="van-popview van-jdpop jdpop animate__animated animate__zoomIn"
      >
        <img src="@/assets/c/pbtntwo.png" class="bg" alt=""/>
        <div class="jdview">
          <div class="jshead">
            <img src="@/assets/c/pbtnone.png" class="bg" alt=""/>
            <div class="jheadview">
              {{ $t("new.gui") }}
            </div>
          </div>
          <div
              class="guiname"
              style="overflow-y: scroll; height: 280px"
              v-html="rule"
          ></div>
          <div class="jsheadbot" @click.stop="gzshow = false">
            <img src="@/assets/c/pbtnthree.png" class="bg" alt=""/>
            <div class="jheadview">
              {{ $t("new.zhixiao") }}
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {mapState, mapActions} from "vuex";
import {Toast} from "vant";
import {showToast, useNumberAnimation, getToken} from "@/libs/util.js";
import {ajaxData} from "@/api/ajax";
import Web3 from "web3";
import sjdcAbi from "@/abi/sjdcAbi";
import yyds_Abi from "@/abi/yydsAbi";
import buyAbi from "@/abi/buyAbi";
import InvestAbi from "@/abi/Invest-abi.json";
import Erc20Abi from "@/abi/erc20Abi.js";
import {mul} from "@/libs/math.js";
import {CoinContract} from "@/libs/Contract.js";
import {INVEST_ADDRESS, USDT_ADDRESS} from "@/libs/ContractAddress.js";

export default {
  data() {
    return {
      jdshow: false,
      name_en: "",
      ico_order: [],
      address: "",
      rule: "",
      gmc_price: 0,
      gmc_token: "0xe9D505ca4a71AFAE9d03a82837A0BFb156a5b598",
      // gmc_token:"0xb9fF8b70A186778EbE190CA7a132Ac193E3DE177",
      usdt_token: "0x55d398326f99059fF775485246999027B3197955",
      buy_token: "0x48B9b78a1F566a5020534457579f4eD286160858",
      select_number: 0,
      select_number_gmc: 0,

      buy_icoBase: 0,
      buy_ico: 0,

      percentage: 0,
      number_array: [],
      leitype: 1,
      gzshow: false, //规则弹窗
      web3Provider: null,
      web3: null,

      parent_array: {},
      price_info: [
        {
          num: "0.1",
          price: "0.1",
        },
        {
          num: "0.2",
          price: "0.2",
        },
        {
          num: "0.3",
          price: "0.3",
        },
        {
          num: "0.4",
          price: "0.4",
        },
        {
          num: "0.5",
          price: "0.5",
        },
        {
          num: "0.6",
          price: "0.6",
        },
      ],
      word1: "",
      word2: "",

      usdtContract: {},
      usdtBalance: 0,
      usdtAllowance: 0,
      btnDisabled: false,
    };
  },
  created() {
    let vm = this;
    if (window.ethereum) {
      vm.web3Provider = window.ethereum;
      vm.web3 = new Web3(vm.web3Provider);
    }
    this.init();
    vm.getIco();
  },
  computed: mapState(["icoData"]),
  watch: {
    buy_icoBase(newVal) {
      if (newVal > 0) {
        useNumberAnimation(newVal, (num) => {
          this.buy_ico = num.toFixed(0);
        });
      }
    },
  },
  methods: {
    ...mapActions["setIcoData"],
    async init() {
      this.getContract();
      await this.getUsdtBalance();
      console.log(`当前用户余额${this.usdtBalance / Math.pow(10, 18)}`);
      this.usdtAllowance = await this.getUsdtAllowance(INVEST_ADDRESS);
      this.usdtAllowance = this.usdtAllowance / Math.pow(10, 18);
      console.log("授权额度", this.usdtAllowance);
    },
    getContract() {
      this.usdtContract = new CoinContract(Erc20Abi, USDT_ADDRESS);
      console.log("usdtContract", this.usdtContract);
    },
    async getUsdtBalance() {
      this.usdtBalance = await this.usdtContract.balanceOf();
    },
    async getUsdtAllowance(address) {
      return await this.usdtContract.allowance(address);
    },
    approve(val, key) {
      if (this.btnDisabled) return;
      this.btnDisabled = true;
      Toast.loading({
        forbidClick: true,
        duration: 0,
      });
      this.usdtContract
          .approve("100000000000000000000000", INVEST_ADDRESS)
          .then((res) => {
            this.btnDisabled = false;
            let interval = setInterval(() => {
              this.usdtContract
                  .getTransactionReceipt(res)
                  .then(async (res1) => {
                    console.log(`授权结果: ${res1}`);
                    if (res1 != null) {
                      Toast.clear();
                      this.usdtAllowance =
                          await this.getUsdtAllowance(
                              INVEST_ADDRESS
                          );
                      showToast(this.$t("授權成功"));
                      clearInterval(interval);
                    }
                  })
                  .catch((err) => {
                    Toast.clear();
                  });
            }, 2000);
          })
          .catch((err) => {
            Toast.clear();
            this.btnDisabled = false;
          });
    },
    async pay() {
      if (!getToken()) {
        showToast(this.$t("execute_connect_wallet"));
        return;
      }
      if (this.usdtAllowance <= 0) {
        this.approve();
        return;
      }
      if (this.btnDisabled) return;
      this.btnDisabled = true;
      Toast.loading({
        forbidClick: true,
        duration: 0,
      });
      // 生成订单
      let order = await this.getOrder();
      console.log(order);
      if (!order) return;
      // 支付合约
      await this.invest_contract_pay(order);
    },
    async getOrder() {
      let res = await ajaxData("/ico/buy", {
        num: this.select_number_gmc,
        usdt: this.select_number,
      }).catch((e) => (this.btnDisabled = false));
      console.log(res);
      if (res.code == 0) {
        return res.data;
      } else {
        this.btnDisabled = false;
      }
    },
    async payOk(order, payhash) {
      if (this.usdtAllowance <= 0) {
        await this.approve();
        return;
      }
      let res = await ajaxData("/ico/pay", {
        id: order.orderid,
        amount: order.amount,
        hash: payhash,
      }).catch((e) => (this.btnDisabled = false));
      console.log(res);
      if (res.code == 0) {
        return res.data;
      } else {
        this.btnDisabled = false;
      }
    },
    // 业务
    async invest_contract_pay(order) {
      console.log(order);
      // amount    orderid   paytype
      let amount = this.web3.utils.toWei(
          order.amount,
          "ether"
      );
      console.log("amount", amount);
      let contract = new CoinContract(InvestAbi, INVEST_ADDRESS);
      console.log("contract", contract);
      let hash = "";
      // vm.invite = "0x8708b44673088871b8A03A81Af1f999ba0e0fF1b";
      contract
          .invest(order.paytype, order.orderid, amount)
          .then((res) => {
            console.log("hash", res);
            hash = res;
            let interval = setInterval(() => {
              this.usdtContract
                  .getTransactionReceipt(res)
                  .then(async (res1) => {
                    console.log(`结果: ${res1}`);
                    if (res1 != null) {
                      Toast.clear();
                      showToast(this.$t("購買成功"));
                      await this.payOk(order, res);
                      this.getIco();
                      clearInterval(interval);
                    }
                  })
                  .catch((err) => {
                    showToast(this.$t("purchase_fail"));
                    Toast.clear();
                  });
            }, 2000);
          })
          .catch((e) => {
            Toast.clear();
            this.btnDisabled = false;
          }).finally(() => {
        this.btnDisabled = false;
      })
      return hash;
    },
    buy() {
      let vm = this;
      if (vm.select_number == 0) {
        showToast("请先选择数量");
        return false;
      }
      let contract = new vm.web3.eth.Contract(buyAbi, vm.buy_token);

      // contract.methods.setReward1present(vm.web3.utils.toWei("15", 'ether')).call((error, result) => {
      //     console.log(error)
      //     console.log(result)
      // })
      // contract.methods.setReward1present(vm.web3.utils.toWei("15", 'ether')).call()
      //     .then(balance => {
      //         console.log(balance)
      //         // console.log(balance.toString())100000000
      //     })
      //     .catch(error => {
      //         console.error('出错了:', error);
      //     });

      // return false

      const MAX_INT =
          "115792089237316195423570985008687907853269984665640564039457584007913129639935";
      let usdt_contract = new vm.web3.eth.Contract(
          yyds_Abi,
          vm.usdt_token
      );
      usdt_contract.methods
          .allowance(vm.address, vm.buy_token)
          .call((error, result) => {
            if (error) {
              console.error("获取授权额度失败:", error);
              return;
            }

            let number = vm.web3.utils.toWei(
                vm.select_number.toString(),
                "ether"
            );
            if (result >= number) {
              // 调用合约函数
              // contract.methods.setReward2present(5).send({
              contract.methods
                  .buy(
                      vm.web3.utils.toWei(
                          vm.select_number.toString(),
                          "ether"
                      ),
                      // "0x3865d21c24163c05C02336f5749928A7D53b5385",
                      this.parent_array.parent_address,
                      // "0x3865d21c24163c05C02336f5749928A7D53b5385"
                      this.parent_array.parent_parent_address
                  )
                  .send({
                    from: vm.address,
                  })
                  .on("transactionHash", (hash) => {
                    ajaxData("/ico/buy", {
                      hash: hash,
                      usdt: vm.select_number,
                    }).then((response) => {
                      showToast("购买成功");
                      console.log(response);
                    });
                    console.log(`交易哈希: ${hash}`);
                  })
                  .on("receipt", (receipt) => {
                    console.log(`收据: ${JSON.stringify(receipt)}`);
                  })
                  .on(
                      "confirmation",
                      (confirmationNumber, receipt) => {
                        console.log(`确认: ${confirmationNumber}`);
                        console.log(receipt);
                      }
                  )
                  .on("error", (error) => {
                    showToast(`错误: ${error}`);
                  })
                  .then((receipt) => {
                    // showToast("请再次点击购买按钮")
                    console.log(
                        `合约调用成功，收据: ${receipt.transactionHash}`
                    );
                  });

              // 获取代币余额
              // contract.methods.buy(vm.web3.utils.toWei(vm.select_number.toString(), 'ether'),"0x3865d21c24163c05C02336f5749928A7D53b5385","0x3865d21c24163c05C02336f5749928A7D53b5385").call()
              //     .then(balance => {
              //         console.log(balance)
              //         // console.log(balance.toString())100000000
              //     })
              //     .catch(error => {
              //         console.error('出错了:', error);
              //     });
            } else {
              // 调用合约函数
              usdt_contract.methods
                  .approve(vm.buy_token, MAX_INT)
                  .send({
                    from: vm.address,
                  })
                  .on("transactionHash", (hash) => {
                    console.log(`交易哈希: ${hash}`);
                  })
                  .on("receipt", (receipt) => {
                    console.log(`收据: ${JSON.stringify(receipt)}`);
                  })
                  .on(
                      "confirmation",
                      (confirmationNumber, receipt) => {
                        console.log(`确认: ${confirmationNumber}`);
                        console.log(receipt);
                      }
                  )
                  .on("error", (error) => {
                    showToast(`错误: ${error}`);
                  })
                  .then((receipt) => {
                    showToast("请再次点击购买按钮");
                    console.log(
                        `合约调用成功，收据: ${receipt.transactionHash}`
                    );
                  });
            }
          });
    },
    changeNumber(val) {
      let vm = this;
      vm.select_number = val.num;
      vm.select_number_gmc = val.price;
    },
    async getIco() {
      let vm = this;
      await this.$store.dispatch("setIcoData");
      try {
        vm.buy_icoBase = this.icoData?.buy_ico;
        if (this.icoData?.ico?.price_info.length > 0) {
          if (!vm.select_number) {
            vm.changeNumber(this.icoData?.ico?.price_info[0]);
          }
        }
      } catch (e) {
      }
    },
    // getNotice() {
    //     let vm = this;
    //     ajaxData("/setting", { key: "invite" }).then((response) => {
    //         if (localStorage.getItem("locale") == "zh") {
    //             vm.rule = response.data.setting.rule;
    //             vm.rule_title = response.data.setting.title;
    //         } else {
    //             vm.rule = response.data.setting.rule_en;
    //             vm.rule_title = response.data.setting.title_en;
    //         }
    //     });
    // },
    goHome() {
      this.$router.go(-1);
    },
    getjie(e) {
      this.leitype = e;
      this.jdshow = true;
    },
    setGzshow() {
      this.gzshow = true;
      this.getNotice();
    },
    getNotice(key) {
      let vm = this;
      ajaxData("/setting", {key: "ico"}).then((response) => {
        if (localStorage.getItem("locale") == "zh") {
          vm.rule = response.data.setting.rule;
          vm.rule_title = response.data.setting.title;
        } else {
          vm.rule = response.data.setting.rule_en;
          vm.rule_title = response.data.setting.title_en;
        }
      });
    },
  },
};
</script>


<style scoped lang="less">
p {
  margin: 0;
  padding: 0;
}

.proposeList {
  width: 100%;
  background-color: rgb(28, 32, 43);
  min-height: 100vh;
  padding-bottom: 80px;
  box-sizing: border-box;
  // overflow: hidden;
  // position: relative;
  .img_jd_b {
    position: absolute;
    top: -20px;
    width: 100%;
  }

  .jieview {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 36% 15px 0;

    .jiefix {
      position: fixed;
      right: 0;
      top: 13%;
      display: flex;
      flex-direction: column;
      z-index: 10;

      .fone {
        position: relative;
        width: 24px;
        height: 84px;
        margin-bottom: 10px;

        .guiview {
          position: relative;
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          .icon_gz {
            width: 16px;
            height: 16px;
            margin-bottom: 3px;
            position: relative;
            // left: 1px;
          }

          .guiname {
            font-weight: 500;
            color: #26e7fe;
            font-size: 10px;
            padding-right: 2px;
            padding-top: 3px;
            writing-mode: vertical-rl;
            letter-spacing: 5px;
          }
        }
      }
    }

    .jienav {
      position: relative;
      height: 235px;

      .navitem {
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 15px;

        // justify-content: center;
        .navs {
          display: flex;
          flex-direction: row;
          margin-bottom: 15px;

          .shuview {
            width: 82px;
            height: 30px;
            position: relative;
            margin: 4px 4px;

            .shuitems {
              position: relative;
              width: 100%;
              height: 100%;
              font-weight: bold;
              font-size: 15px;
              color: #999999;
              display: flex;
              align-items: center;
              justify-content: center;
              padding-top: 2px;
            }

            .img_slbj_n {
              position: absolute;
              width: 100%;
              height: 100%;
            }

            .img_slbj_s {
              position: absolute;
              width: 100%;
              height: 100%;
              display: inline-block;
              display: none;
            }
          }

          .sactive {
            .img_slbj_s {
              display: inline-block;
            }

            .img_slbj_n {
              display: none;
            }

            .shuitems {
              color: #26e7fe;
            }
          }
        }

        .navstwo {
          position: relative;
          display: flex;
          flex-direction: row;
          margin-bottom: 8px;
          padding-top: 13px;

          .shuview {
            // width: 140px;
            // height: 60px;
            // position: relative;
            // margin: 0 12px;
            // background: #1A3542;
            // border-radius: 10px;
            // border: 0.5px solid #26E7FE;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
          }

          .shuone {
            display: flex;
            flex-direction: row;
            align-items: center;

            .gouname {
              font-weight: 500;
              font-size: 10px;
              color: #26e7fe;
            }

            .wen {
              width: 10px;
              height: 10px;
              margin-left: 2px;
              position: relative;
              top: -2px;
            }
          }

          .dnum {
            font-weight: bold;
            font-size: 22px;
            color: #26e7fe;
          }
        }

        .goumai {
          width: 134px;
          height: 48px;
          position: relative;
          margin-top: 15px;

          .gouview {
            position: relative;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: bold;
            font-size: 18px;
            padding-top: 3px;
            color: #26e7fe;
          }
        }

        .tishi {
          font-weight: 500;
          font-size: 10px;
          display: block;
          text-align: center;
          color: #999999;
        }

        .xianview {
          width: 80%;
          height: 40px;
          display: flex;
          position: relative;
          margin: 10px 0;

          .xianitem {
            display: flex;
            position: relative;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;
            font-weight: bold;
            font-size: 18px;
            color: #26e7fe;
          }
        }

        .jindu {
          width: 90%;
          height: 15px;
          position: relative;
          background: #1a3542;
          border-radius: 7px;
          border: 0.5px solid #26e7fe;
          overflow: hidden;

          .jins {
            position: absolute;
            height: 100%;
            left: 0;
            //    background: #26E7FE;
            // border-radius: 7px;
          }
        }

        .jinshu {
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          font-size: 15px;
          color: #23afc2;
          margin-top: 10px;
        }
      }
    }

    .jienavone {
      height: 167px;
      margin-bottom: 10px;
    }

    .jienavtwo {
      height: 100px;
      margin-top: 12px;
    }
  }

  .bg {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .header {
    height: 50px;
    // margin-bottom: 12px;
    // padding: 40px 12px 0 12px;
    padding: 6px;
    box-sizing: border-box;
    background: rgba(52, 56, 75, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    position: sticky;
    width: 100%;
    z-index: 10;
    top: 0;

    img {
      width: 55px;
      height: 55px;
      position: absolute;
      left: 10px;
    }

    span {
      font-weight: bold;
      font-size: 18px;
      color: #ffffff;
    }
  }

  .mhead {
    // position: relative;
    // top: 50px;
  }
}

.van-jdpop {
  position: relative;
  padding: 0;
  width: 330px;
  height: 427px;
  background: transparent !important;

  .guiname {
    color: #00ffff;
  }

  .jdview {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 15px;
    display: flex;
    flex-direction: column;

    .jshead {
      position: relative;
      width: 103px;
      height: 37px;
      margin: 15px auto;

      .jheadview {
        position: relative;
        width: 100%;
        height: 100%;
        font-weight: bold;
        font-size: 16px;
        color: #00ffff;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .tview {
      display: flex;
      flex-direction: column;
      // align-items: center;
      width: 100%;

      .tone {
        width: 80%;
        font-weight: 500;
        font-size: 12px;
        color: #26e7fe;
      }

      .ttwo {
        font-weight: 500;
        font-size: 12px;
        color: #26e7fe;
        display: block;
        width: 20%;
        text-align: center;
      }

      .tthree {
        font-weight: 500;
        font-size: 12px;
        color: #26e7fe;
        display: block;
        width: 20%;
        text-align: right;
      }

      .tlist {
        padding: 15px;
        background: #006c83;
        border-radius: 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 96%;
        margin: 0 auto 10px;

        .tleft {
          font-weight: 500;
          font-size: 12px;
          color: #ffffff;
        }
      }
    }

    .jsheadbot {
      width: 150px;
      height: 54px;
      position: relative;
      margin: 15px auto 20px;


      .jheadview {
        position: relative;
        width: 100%;
        height: 100%;
        font-weight: bold;
        font-size: 14px;
        color: #00ffff;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .oneview {
      padding: 0 15px;
      margin-bottom: 15px;
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }
}

.guiname {
  font-weight: 500;
  font-size: 13px;
  color: #ffffff;
}
</style>
